import { Component, OnInit, NgZone } from '@angular/core';

@Component({
  selector: 'app-public-sidebar',
  templateUrl: './public-sidebar.component.html',
  styleUrls: ['./public-sidebar.component.css']
})
export class PublicSidebarComponent implements OnInit {

  constructor() {
    
  }

  ngOnInit() {
  }
}
